import React, { useState } from "react";
import Datatable from "../../../components/shared/datatable/Datatable";
import useTranslator from "../../../hooks/useTranslator";

const EmployeeHistory = ({ setShow, modalMode, columns, tableData }) => {
  const [page, setPage] = useState(1);
  const handlePageChange = (page) => {
    setPage(page);
  };
  const handleClick = () => {
    setShow(false);
  };
  const { _t } = useTranslator()

  return (
    <div>
      <div className="breadcrumbs d-flex">
        <p onClick={handleClick}>{_t("washing", "Washing")}  / </p>{" "}
        <span>
          <p className="current">{_t("history", "History")}</p>

        </span>
      </div>
      <Datatable
        title={
          modalMode === "morning"
            ? _t("morning_shift_employee_history", "Morning Shift Employee History")
            : _t("evening_shift_employee_history", "Evening Shift Employee History")
        }
        columns={columns}
        tableData={tableData?.data}
        // onClick={handleAddRecord}
        // buttonTitle={"Add Cases in Cold Storage"}
        pagination
        page={page}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default EmployeeHistory;
